module.exports = "/images/gotham-4.jpg";